import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import {
  handleSentimentHighlight,
  getProcessedTextPreview,
} from "../../../utilities/NewsUtilities";
import { formatDisplayDate } from "../../../utilities/CommonUtilities";

const NewsDetailDiv = ({ news, onClose }) => {
  const [highlightedArticle, setHighlightedArticle] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const displayDate = formatDisplayDate(new Date(news.data_timestamp));
  const title = news.document_name
    ? news.document_name
    : getProcessedTextPreview(news.processed_text, 100);
  const sourceUrl = news.public_data_source_url;
  const newsArticle = news.processed_text;
  const relevanceIndicator = (() => {
    const score = news.ner_relevance_score;
    if (score > 0.5) {
      return {
        color: "green",
        icon: <i className="fa-solid fa-caret-up" />,
        title: "High Relevance",
      };
    } else if (score > 0) {
      return {
        color: "#ffc107",
        icon: <i className="fa-solid fa-xs fa-circle" />,
        title: "Moderate Relevance",
      };
    } else {
      return {
        color: "red",
        icon: <i className="fa-solid fa-caret-down" />,
        title: "Low Relevance",
      };
    }
  })();

  const handleClose = () => {
    setHighlightedArticle(null);
    onClose();
  };

  const toggleHighlight = async () => {
    setIsLoading(true);
    if (highlightedArticle) {
      setHighlightedArticle(null);
    } else {
      await handleSentimentHighlight(newsArticle, setHighlightedArticle);
    }
    setIsLoading(false);
  };

  return (
    <div className="d-flex flex-column h-100">
      <div className="w-100">
        <div className="text-start">
          <div className="d-flex justify-content-between align-items-center border-bottom mb-2 text-dark-gray">
            <div className="fw-bold h4">{title}</div>
          </div>
          <div className="d-flex justify-content-start align-items-center text-muted gap-2 mb-2">
            <div>
              <a
                href={sourceUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted"
              >
                <i className="fa-solid fa-globe" /> Source
              </a>
            </div>
            |
            <div>
              <i className="fa-regular fa-calendar me-2" />
              {displayDate}
            </div>
            {news.ner_relevance_score  && (
              <div>
                | Relevance:
                <span
                  style={{
                    color: relevanceIndicator.color,
                    fontSize: "15px",
                  }}
                  title={relevanceIndicator.title}
                  className="ms-2"
                >
                  {relevanceIndicator.icon}
                  {news.ner_relevance_score}
                </span>
              </div>
            )}
          </div>
          {news.translated_document_name && (
            <div className="d-flex justify-content-start align-items-center text-muted mb-4">
              Translation: {news.translated_document_name}
            </div>
          )}
        </div>
      </div>
      <div className="flex-grow-1 overflow-auto mb-2 text-light-gray">
        {highlightedArticle ? (
          <div dangerouslySetInnerHTML={{ __html: highlightedArticle }} />
        ) : (
          <p>{newsArticle}</p>
        )}
      </div>
      <div className="mt-auto w-100 d-flex justify-content-between">
        <Button
          onClick={toggleHighlight}
          variant={isLoading || highlightedArticle ? "secondary" : "primary"}
        >
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
              Processing...
            </>
          ) : highlightedArticle ? (
            "Revert Highlight"
          ) : (
            "Highlight Sentiment"
          )}
        </Button>
        <div onClick={handleClose}>
              <button className="btn btn-secondary"> Close </button>
            </div>
      </div>
    </div>
  );
};

export default NewsDetailDiv;
